import { render, staticRenderFns } from "./term3.vue?vue&type=template&id=357dd291&"
import script from "./term3.vue?vue&type=script&lang=js&"
export * from "./term3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports